import React from 'react';

var ConflictErrorPopup = React.createClass({
	handleCloseClick: function(){
		this.props.conflictError("close");
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function(){
		return(
			<div className="modal__mask" onClick = {this.handleCloseClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Conflict Error</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}><i className="fa  fa-close"> </i></a> </div>
				  <div className="modal__body">
				    <div className="form__row clearfix">
					    <p>There is a conflict with this package. "{this.props.slug}" package already exists in your account.</p>
				    </div>  
				  </div>
				</div>
			</div>
		);
	}
});

export {ConflictErrorPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ConflictErrorPopup.jsx
 **/